export const filterOptions = [
  { name: "Barcode", value: "barcode" },
  { name: "Serial Number", value: "serial" },
  { name: "Date Created", value: "date" },
];
